<div #cropPanel [ngClass]="'crop-panel-'+popupStyle" [attr.width]="dropZoneInfo.width" [attr.height]="dropZoneInfo.height">    
    <span [ngClass]="isFullScreenPopUp ? 'btn-remove-full-screen' : 'btn-remove-'+popupStyle" (click)="removeBtnClick()">
        <img  class="close-icon" src="assets/multimedia-module/close-icon.png">    
    </span>
    <svg [attr.width]="dropZoneInfo.width" [attr.height]="dropZoneInfo.height"  version="1.1" xmlns="http://www.w3.org/2000/svg" >
        <g>
            <image #image1 [attr.transform]="transformVal"  class="original-img"  
                [attr.width]="imageWidth" [attr.height]="imageHeight" [attr.href]="imageUrl" >
            </image>
            <clipPath id="mainImg">                
                <rect [attr.x]="cropperAreaX" [attr.y]="cropperAreaY" height="600" width="600" />
            </clipPath>
        </g>

        <g>
            <image #image2  [attr.transform]="transformVal" [attr.width]="imageWidth" [attr.height]="imageHeight" 
            class="inner-img" id="innerImg" [attr.href]="imageUrl" ></image>
            <clipPath id="clipping">
                <rect *ngIf="isSqureCrop" [attr.x]="cropperAreaX" [attr.y]="cropperAreaY" [attr.height]="sqrWidthHeight" [attr.width]="sqrWidthHeight" />
                <circle *ngIf="!isSqureCrop"  #cropCircle [attr.cx]="circleCropperX" [attr.cy]="circleCropperY" [attr.r]="circleRadius" />
            </clipPath>
        </g>
    </svg>
</div>

<div [ngClass]="'button-panel-'+popupStyle">
    <div class="zoom-button">
        <img class="zoom-image" src="assets/multimedia-module/zoom-minus.png" (click)="zoomOut(true)">
    </div>
    <input id ="zoomBar" type="range" #zoomBar="ngModel" min="1" max="201" [attr.value]="zoomValue" step="5"
     (change)="zoomBySlider(zoomValue)" [(ngModel)]="zoomValue">
    <div class="zoom-button">
        <img class="zoom-image" src="assets/multimedia-module/zoom-plus.png" (click)="zoomIn(true)">
    </div>
</div>